import gql from "graphql-tag";

import type {ApolloGqlClient} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {logoutMutationType} from "./__graphql-types__/index.ts";

export const LOGOUT_MUTATION: GqlOperation<
    logoutMutationType["response"],
    logoutMutationType["variables"]
> = gqlOp(gql`
    mutation logoutMutation(
        $allowClever: Boolean!
        $continueUrl: String!
        $finish: Boolean!
    ) {
        logout(
            allowClever: $allowClever
            continueUrl: $continueUrl
            finish: $finish
        ) {
            continueUrl
        }
    }
`);

export const logout = (
    gqlClient: ApolloGqlClient,
    options: logoutMutationType["variables"],
): Promise<string> => {
    return gqlClient
        .mutate(LOGOUT_MUTATION, {
            variables: options,
        })
        .then((result) => {
            return result.data?.logout?.continueUrl ?? "";
        })
        .catch((error) => {
            // Throw a generic error.
            throw new KAError("Failed to logout ", Errors.Internal);
        });
};
